import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}
export interface MainMenuItems {

  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}
let MENUITEMS = [
  {
    label: 'پنل مدیریت',
    main: [
      {
        state: 'dashboard',
        short_label: 'D',
        name: 'میز کار',
        type: 'sub',
        icon: 'ti-home',
        children: [
          {
            state: 'dashboard-default',
            name: 'میز کار'
          },
          {
            state: 'dashboard-project',
            name: 'اطلاعات اجمالی'
          },
        ]
      },
      {
        state: 'user',
        name: 'کاربران',
        type: 'sub',
        icon: 'icofont icofont-users-alt-2',
        children: [
          {
            state: 'user-list',
            name: 'لیست کاربران'
          },
          {
            state: 'user-access',
            name: 'مدیریت سطح دسترسی'
          },
          {
            state: 'user-valuable',
            name: 'نمایش کاربران با ارزش'
          },
        ]
      },
      {
        state: 'game',
        name: 'مسابقات ورزشی',
        type: 'sub',
        icon: 'icofont icofont-trophy-alt',
        children: [
          {
            state: 'game-add',
            name: 'مسابقه جدید'
          },
          {
            state: 'game-list',
            name: 'لیست مسابقه ها'
          },
          {
            state: 'daramad-dore',
            name: 'گزارش مالی دوره ها'
          }
        ]
      },
      {
        state: 'questions-game',
        name: 'مسابقات فرهنگی',
        type: 'sub',
        icon: 'icofont icofont-trophy-alt',
        children: [
          {
            state: 'questions-game-add',
            name: 'مسابقه جدید'
          },
          {
            state: 'questions-game-list',
            name: 'لیست مسابقه ها'
          }
        ]
      }, {
        state: 'namayandeh',
        name: 'نماینده',
        type: 'sub',
        icon: 'icofont icofont-ui-user-group',
        children: [
          {
            state: 'namayandeh-kol-add',
            name: 'افزودن نماینده کل '
          }, {
            state: 'namayandeh-kol-list',
            name: 'لیست نماینده کل'
          }, {
            state: 'namayandeh-joz-add',
            name: 'افزودن نماینده جز '
          }, {
            state: 'namayandeh-joz-list',
            name: 'لیست نماینده جز'
          }, {
            state: 'namayandeh-kol-charge',
            name: 'شارژ حساب نماینده کل'
          }
        ]
      }, {
        state: 'automatic-ending-job',
        name: 'عملیات خودکار',
        type: 'sub',
        icon: 'ti-check-box',
        children: [
          {
            state: 'automatic-ending-job-add',
            name: 'افزودن عملیات خودکار'
          },
          {
            state: 'automatic-ending-job-list',
            name: 'لیست عملیات ها'
          }
        ]
      }
      , {
        state: 'copy',
        name: 'عملیات کپی',
        type: 'sub',
        icon: 'icofont icofont-copy-alt',
        children: [
          {
            state: 'code-kol',
            name: 'کد کل',
            type: 'sub',
            icon: 'icofont icofont-bank',
            children: [
              {
                state: 'code-kol-add',
                name: 'افزودن کد کل'
              },
              {
                state: 'code-kol-list',
                name: 'لیست کد کل'
              }
            ]
          },
          {
            state: 'code-joz',
            name: 'کد جز',
            type: 'sub',
            icon: 'icofont icofont-bank',
            children: [
              {
                state: 'code-joz-add',
                name: 'افزودن کد جز'
              },
              {
                state: 'code-joz-list',
                name: 'لیست کد جز'
              }
            ]
          }
        ]
      }
      , {
        state: 'league',
        name: 'نام لیگ',
        type: 'sub',
        icon: 'ti-flag-alt',
        children: [
          {
            state: 'league-add',
            name: 'افزودن لیگ'
          },
          {
            state: 'league-list',
            name: 'لیست لیگ ها '
          },
        ]
      }
      , {
        state: 'game-name',
        name: 'نام بازی',
        type: 'sub',
        icon: 'ti-cup',
        children: [
          {
            state: 'game-name-add',
            name: 'افزودن نام بازی'
          },
          {
            state: 'game-name-list',
            name: 'لیست نام بازی ها '
          },
        ]
      }
      , {
        state: 'game-help',
        name: 'راهنمای مسابقه',
        type: 'sub',
        icon: 'ti-help-alt',
        children: [
          {
            state: 'game-help-add',
            name: 'افزودن را هنما'
          },
          {
            state: 'game-help-list',
            name: 'لیست راهنما ها'
          },
        ]
      }
      , {
        state: 'game-type',
        name: 'نوع مسابقه',
        type: 'sub',
        icon: 'ti-stamp',
        children: [
          {
            state: 'game-type-add',
            name: 'نوع مسابقه جدید'
          },
          {
            state: 'game-type-list',
            name: 'لیست نوع مسابقه ها'
          },
        ]
      }
      , {
        state: 'takhfif',
        name: 'تخفیف',
        type: 'sub',
        icon: 'icofont icofont-cur-dollar-minus',
        children: [
          {
            state: 'takhfif-add',
            name: 'تخفیف جدید'
          },
          {
            state: 'takhfif-list',
            name: 'لیست تخفیف ها'
          },
        ]
      }
      , {
        state: 'card',
        name: 'فرم کاربران',
        type: 'sub',
        icon: 'ti-files',
        children: [
          {
            state: 'card-list',
            name: 'لیست فرم ها'
          }
        ]
      }
      , {
        state: 'accountancy',
        name: 'گزارش',
        type: 'sub',
        icon: 'ti-file',
        children: [
          {
            state: 'report-namayandeh-kol-charge',
            name: 'گزارش شارژ حساب نماینده کل'
          },
          {
            state: 'report-charge-admin',
            name: 'تغییر موجودی از طریق مدیریت'
          },
          {
            state: 'tarakonesh-bank',
            name: 'تراکنش بانک'
          },
          {
            state: 'mojodi-sandogh-users',
            name: 'موجودی صندوق کاربران'
          },
          {
            state: 'withdrawal',
            name: 'درخواست برداشت'
          },
          {
            state: 'paycardstocard',
            name: 'واریز کارت به کارت'
          }
        ]
      }
      , {
        state: 'email',
        name: 'پیام ها',
        type: 'sub',
        icon: 'ti-email',
        children: [
          {
            state: 'compose-email',
            name: 'ارسال پیام گروهی'
          },
          {
            state: 'email-inbox',
            name: 'پیام کاربران'
          },
          {
            state: 'compose-email',
            name: 'پیام جدید'
          },
          //{
          //  state: 'email-read',
          //  name: 'پیامک'
          //}
        ]
      }
      , {
        state: 'voucher',
        name: 'کد شارژ',
        type: 'sub',
        icon: 'ti-id-badge',
        children: [
          {
            state: 'voucher-add',
            name: 'تولید کد شارژ'
          },
          {
            state: 'voucher-list',
            name: 'لیست کدها'
          },
        ]
      }
      , {
        state: 'backup',
        name: 'پایگاه داده',
        type: 'sub',
        icon: 'ti-server',
        children: [
          {
            state: 'backup-add',
            name: 'مدیریت پایگاه داده'
          },
          {
            state: 'backup-list',
            name: 'لیست فایل های پشتیبان'
          },
        ]
      }
      , {
        state: 'xml',
        name: 'خروجی XML',
        type: 'sub',
        icon: 'fa fa-file-code-o',
        children: [
          {
            state: 'mother-server',
            name: 'تنظیمات خروجی',
            type: 'sub',
            icon: 'icofont icofont-bank',
            children: [
              {
                state: 'mother-server-add',
                name: 'افزودن تنظیمات خروجی'
              },
              {
                state: 'mother-server-list',
                name: 'لیست تنظیمات خروجی'
              }
            ]
          }
        ]
      },
      {
        state: 'products-groups',
        name: 'گروه محصولات فروشگاه',
        type: 'sub',
        icon: 'ti-cup',
        children: [
          {
            state: 'products-groups-add',
            name: 'افزودن گروه محصول'
          },
          {
            state: 'products-groups-list',
            name: 'لیست گروه های محصولات '
          },
        ]
      },
      {
        state: 'products',
        name: 'محصولات فروشگاه',
        type: 'sub',
        icon: 'ti-cup',
        children: [
          {
            state: 'products-add',
            name: 'افزودن محصول'
          },
          {
            state: 'products-list',
            name: 'لیست محصولات '
          },
        ]
      }
      , {
        state: 'setting',
        name: 'تنظیمات',
        type: 'sub',
        icon: 'ti-settings',
        children: [
          {
            state: 'setting-site',
            name: 'تنظیمات عمومی'
          },
          {
            state: 'setting-shop',
            name: 'تنظیمات فروشگاه'
          },
          {
            state: 'manage-app-card-to-card',
            name: 'مدیریت برنامه کارت به کارت'
          },
          {
            state: 'account-card-to-card',
            name: 'حساب کارت به کارت',
            type: 'sub',
            icon: 'icofont icofont-envolope',
            children: [
              {
                state: 'account-card-to-card-add',
                name: 'افزودن حساب کارت به کارت'
              },
              {
                state: 'account-card-to-card-list',
                name: 'لیست حساب کارت به کارت'
              }
            ]
          },
          {
            state: 'bank',
            name: 'درگاه پرداخت',
            type: 'sub',
            icon: 'icofont icofont-bank',
            children: [
              {
                state: 'bank-add',
                name: 'افزودن درگاه پرداخت'
              },
              {
                state: 'bank-list',
                name: 'لیست درگاه های پرداخت'
              }
            ]
          },
          {
            state: 'sms',
            name: 'سرویس پیامک',
            type: 'sub',
            icon: 'icofont icofont-envolope',
            children: [
              {
                state: 'sms-add',
                name: 'افزودن سرویس پیامک'
              },
              {
                state: 'sms-list',
                name: 'لیست سرویس های پیامک'
              }
            ]
          },
          //{
          //  state: 'mother-server',
          //  name: 'سرور مادر',
          //  type: 'sub',
          //  icon: 'icofont icofont-bank',
          //  children: [
          //    {
          //      state: 'mother-server-add',
          //      name: 'افزودن سرور مادر'
          //    },
          //    {
          //      state: 'mother-server-list',
          //      name: 'لیست سرور مادر'
          //    }
          //  ]
          //},
          {
            state: 'telegram-admin',
            name: 'تلگرام',
            type: 'sub',
            icon: 'icofont icofont-send-mail',
            children: [
              {
                state: 'telegram-admin-add',
                name: 'افزودن کاربر تلگرام'
              },
              {
                state: 'telegram-admin-list',
                name: 'لیست کاربر های تلگرام'
              }
            ]
          },
          {
            state: 'term-service',
            name: 'قوانین و مقررات'
          }
        ]
      }
    ]
  },
];

@Injectable()
export class MenuItems {

  getAll(): Menu[] {

    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}



// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/shared/menu-items/menu-items.ts